import {AjaxRequest} from "./ajax";
import {PromiseRejecter, PromiseResolver} from "./types";

export interface GETCommand {
	runGet(command: string, params: {}): Promise<{}|void>
}
export interface POSTCommand {
	runPost(command: string, params: {}): Promise<{}|void>
}

export class CommandMock implements POSTCommand, GETCommand {
	constructor(private value: any) {}

	runGet<Result>(command: string, params: {}): Promise<Result> {
		return Promise.resolve(this.value)
	}

	runPost<Result>(command: string, params: {}): Promise<Result> {
		return Promise.resolve(this.value)
	}
}

export class CommandPosterMock<Result> implements POSTCommand {
	constructor(private value: Result) {}

	runPost(command: string, params: {}): Promise<Result> {
		return Promise.resolve(this.value)
	}
}

export class CommandPosterRejecterMock implements POSTCommand {
	constructor(private reason: string) {}
	
	runPost<Result>(command: string, params: {}): Promise<Result> {
		return Promise.reject<Result>(this.reason)
	}
}

export class CommandCaller implements GETCommand, POSTCommand {
	private ajaxRequest:AjaxRequest

	constructor(ajaxPageUrl:string) {
		this.ajaxRequest = new AjaxRequest(ajaxPageUrl)
	}

	public runGet(command:string, params:{} = {}):Promise<{}|void> {
		const data = {
			command:   command,
			noheaders: 1,
			param:     JSON.stringify(params)
		}

		return this.ajaxRequest.runGet<CommandResponse<{}>>(data)
			.then((r:CommandResponse<{}>) => this.handleResponse(r))
	}

	public runPost(command:string, params:{}):Promise<{}|void> {
		const GET_params = {command: command, noheaders: 1}
		const form       = {param: JSON.stringify(params)}
		return this.ajaxRequest.postForm<CommandResponse<{}>>(form, GET_params)
			.then((r:CommandResponse<{}>) => this.handleResponse(r))
	}

	protected handleResponse<Result>(r:CommandResponse<Result>) {
		return new Promise((resolve, reject) => new CommandResultHandler<Result>(resolve, reject).handleResult(r))
	}
}

/**
 * Either error or result should always be defined, but i haven't worked out how to say this in typescript
 */
export type CommandResponse<Result> = {
	error?: CommandError,
	response?: Result
}

export type CommandError = {
	title: string,
	message: string,
}

class CommandResultHandler<Result> {
	constructor(
		private resolver:PromiseResolver<Result>,
		private rejecter:PromiseRejecter<Result>
	) {}

	handleResult(result:CommandResponse<Result>) {
		if (result.error !== null) {
			this.handleError(result.error!) // Not sure how to make this type safe
		} else {
			this.resolver(result.response!) // Not sure how to make this type safe
		}
	}

	handleError(error:CommandError) {
		const message = error.title + "\n\n" + error.message
		alert(message)
		this.rejecter(message)
	}
}



// WEBPACK FOOTER //
// ./src/lib/commands.ts